<template>
  <div class="full-height">
    <div :class="isAma? 'starter-kit-ama': 'starter-kit'">
      <div class="kit-name"><span>{{ label }}</span></div>
      <button :disabled="addedToBasket" class="btn btn-primary add-to-basket-btn cursor-pointer"
        @click="addKitToBasket(name)">
        <span v-if="addedToBasket">{{ $t("addedToBasket") }}</span>
        <span v-else>{{ $t("addToBasket") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import list from '../api/list'
import { mapState } from "vuex";

export default {
  name: "StarterKit",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      addedToBasket: false
    }
  },
  computed: {
    ...mapState({
      isAma: (state) => state.config.isAma
    })
  },
  mounted() {
  },
  methods: {
    addKitToBasket(kitName) {
      this.addedToBasket = true;
      list.getKitItemsForCart(kitName).then((response) => {
        response.data.forEach(element => {
          window.parent.postMessage(
            {
              func: "addToGioielleriaItalianaBasket",
              message: element,
            },
            "*"
          );
        });
      })
    }
  },
}
</script>

<style scoped lang="scss">
.full-height {
  height: 100%;
  flex-grow: 1;
}


.starter-kit-ama {
  background-color: white;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .kit-name {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
    color: var(--ama-green);
    font-family: var(--font-family-reckless);

    span {
      border: 1px solid var(--ama-green);
      padding: 20px;
    }
  }

  .kit-image {
    aspect-ratio: 1/1;
    width: 100%;
  }

  button.add-to-basket-btn {
    background-color: var(--ama-green) !important;
    color: var(--ama-white) !important;
    font-family: var(--font-family-reckless-italic);
    margin-top: 5px;
    border-color: var(--ama-green);
    cursor: pointer;
  }
}

.starter-kit {
  background-color: white;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: 768px) {
    .kit-name {
      font-size: 15px !important;
      line-height: normal;
    }
  }

  .kit-name {
    font-size: 12px;
    font-weight: bold;
    display: block;
    margin: 20px 0px;
    border: 1px solid var(--primary-color-1);
    padding: 10% 30%;
  }

  .kit-image {
    aspect-ratio: 1/1;
    width: 80%;
  }

  button.add-to-basket-btn {
    background-color: var(--primary-color-1) !important;
    color: var(--ama-white) !important;
    font-family: var(--font-family);
    margin-top: 5px;
    border-color: var(--primary-color-1);
    cursor: pointer;
  }
}

@media only screen and (max-width: 768px) {
  .kit-name {
    font-size: 1em
  }

  .add-to-basket-btn {
    font-size: 14px
  }
}
</style>